<template>
  <div class="contact-info--wrapper">
    <div class="container">
      <div v-if="name" class="contact--group">
        <span class="material-symbols-outlined text-gray-500">person</span>
        <div class="meta">
          <p
            class="overflow-hidden whitespace-nowrap text-ellipsis margin-bottom-0"
          >
            {{ name }}
          </p>
        </div>
      </div>
      <div v-if="phoneNumber" class="contact--group">
        <span class="material-symbols-outlined text-gray-500">call</span>
        <div class="meta">
          <p
            class="overflow-hidden whitespace-nowrap text-ellipsis margin-bottom-0"
          >
            {{ phoneNumber }}
          </p>
        </div>
      </div>
      <div v-if="email" class="contact--group">
        <span class="material-symbols-outlined text-gray-500">mail</span>
        <div class="meta">
          <p
            class="overflow-hidden whitespace-nowrap text-ellipsis margin-bottom-0"
          >
            {{ email }}
          </p>
        </div>
      </div>
    </div>
    <button class="send_button cursor-pointer" @click="handleClick">
      <span class="material-symbols-outlined text-white">send</span>
      <span>{{ $t('CONVERSATION.CONTACT_INFO_MESSAGE.BUTTON_TEXT') }}</span>
    </button>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  mixins: [alertMixin],
  props: {
    name: {
      type: String,
      default: '',
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
  },
  computed: {
    formattedPhoneNumber() {
      return this.phoneNumber.replace(/\s|-|[A-Za-z]/g, '');
    },
    rawPhoneNumber() {
      return this.phoneNumber.replace(/\D/g, '');
    },
  },
  methods: {
    handleClick() {
      const { phoneNumber, name } = this;
      bus.$emit(BUS_EVENTS.START_NEW_CONVERSATION, {
        phoneNumber,
        name,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.contact-info--wrapper {
  padding: 5px;
}
.container {
  border-bottom: 1px solid lightgray;
  padding-bottom: 12px;
  margin-bottom: 12px;
}
.send_button {
  display: flex;
  padding: 12px 20px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 5px;
  background: #2abb7f;
  color: white;
  white-space: nowrap;
}
.contact--group {
  align-items: center;
  display: flex;
  margin-top: var(--space-smaller);

  .meta {
    flex: 1;
    margin-left: var(--space-small);
  }

  .link-wrap {
    margin-left: var(--space-small);
  }
}
</style>
